export const NETWORK = "APPDATA_NETWORK";
